export default "__VITE_ASSET__CjEXkvSE__"